import React,{useState} from 'react';
import Alert from "react-bootstrap/Alert";


function Message() {
    const [show, setShow] = useState(true);

    if (show) {
        return (
            <Alert variant="success" onClose={() => setShow(false)} dismissible>
                
                <p>
                    Our Team is working on online appointment
                </p>
            </Alert>
        );
    }
    

    // return <Button onClick={() => setShow(true)}>Show Alert</Button>;
}

export default Message;
